module.exports = __webpack_public_path__ + "media/いつも何度でも.72662188.mp3";